<!--
 * @Author: cryi.liu
 * @Date: 2020-05-14 16:13:09
 * @LastEditTime: 2020-06-14 10:57:58
 * @Description: 上传多媒体文件
 -->
<template>
  <div class="upload-media-file">
    <i-upload
      accept=".mp4,.mp3,.pdf,.jpg"
      :format="['mp4', 'mp3', 'pdf', 'jpg']"
      name="file"
      :headers="{ psstoken }"
      :show-upload-list="false"
      action="/examcentersite/library/import/media"
      :on-format-error="uploadFileFormatError"
      :before-upload="questionMediaBeforeUpload"
      :on-success="questionMediaUploaded">
      <i-button icon="ios-cloud-upload-outline">上传文件</i-button>
    </i-upload>
    <p class="tip">支持扩展名：.mp4、.mp3、.pdf、.jpg</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

/**
 * 属性值 control 验证
 */
function controlValidator(value) {
  const values = ['stem', 'option'];

  return values.includes(value);
}

export default {
  name: 'UploadMediaFile',
  props: {
    control: { type: String, reuqired: true, validator: controlValidator },
    libraryId: { type: String, required: true },
    optionId: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      psstoken: 'authStore/token',
    }),
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setProcessingShowText: 'pageStore/invokeSetProcessingShowText',
    }),
    /**
     * 上传题目表格文件前
     */
    questionMediaBeforeUpload() {
      this.setProcessingShowState({ show: true });
    },
    /**
     *  文件格式校验失败
     */
    uploadFileFormatError() {
      alert('上传文件格式未支持');
      this.setProcessingShowState({ show: false });
    },
    /**
     * 上传题目多媒体文件成功
     */
    questionMediaUploaded(result) {
      if (result.code === '200') {
        this.requestSaveQuestionInfo(result.data)
          .then((saveResult) => {
            if (saveResult.code === '200') {
              alert('上传成功');
              this.setProcessingShowState({ show: false });

              this.$emit('repull-question-info');
            } else {
              alert(saveResult.msg);
              this.setProcessingShowState({ show: false });
            }
          })
          .catch((saveResult) => {
            alert(saveResult.msg);
            this.setProcessingShowState({ show: false });
          });
      } else {
        alert(result.msg);
        this.setProcessingShowState({ show: false });
      }
    },
    /**
     * 请求保存题库题目信息
     */
    requestSaveQuestionInfo({ mediaPath }) {
      let params = {};

      if (this.control === 'stem') { // 题干上传多媒体
        params = {
          id: this.libraryId,
          mediaPath,
        };
      } else if (this.control === 'option') { // 选项上传多媒体
        params = {
          id: this.libraryId,
          options: [
            {
              id: this.optionId,
              mediaPath,
            },
          ],
        };
      }

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.upload-media-file {
  flex: 0 0 20%;
  display: flex;
  justify-content: flex-start;

  /deep/ .ivu-upload {
    display: flex;
    align-items: center;
    margin-left: 12px;
    margin-right: 6px;
  }

  > .tip {
    line-height: 36px;
    vertical-align: middle;
    white-space: nowrap;
    opacity: .56;
  }
}
</style>
